












import { BreadcrumbItem } from '@shared/components/breadcrumbs/types';
import { RouteName } from '@src/app/router/constants/RouteName';
import { capitalize } from '@superbet-group/web.lib.utilities';
import {
    isMobileDevice,
    useI18n,
} from '@superbet-group/web.lib.vue-utilities';
import { defineComponent } from '@vue/composition-api';
import LicencePreferencesContainer from '@accountFederation/modules/settings/LicencePreferencesContainer.vue';

export default defineComponent({
    setup() {
        const { translate } = useI18n();

        const breadcrumbs: BreadcrumbItem[] = [
            {
                label: capitalize(translate('settings')),
                to: {
                    name: RouteName.Account.Settings,
                },
            },
        ];

        return {
            isMobile: isMobileDevice(),
            title: capitalize(translate('pam.licencePreferences.title')),
            breadcrumbs,
        };
    },
    components: {
        LicencePreferencesContainer,
    },
});
